// extracted by mini-css-extract-plugin
export default {"root":"+nCe5AAc","form":"zu5rUniE","field":"yLm45cX7","clear":"_8v+d3XcE","submit":"l6rDnh6R"};